module.exports = __webpack_public_path__ + "img/Hero.02f572c5.png";